import type { PartDefinition } from "./types";
import {
  PART_SPRITE_DEFS,
  ROYGBIV_HUES,
  STARTER_SPRITE_KEYS,
  partIdForSpriteHue,
  spriteGridDimensions,
} from "./partSprites";

const STARTER_SPRITE_SET = new Set<string>(STARTER_SPRITE_KEYS);

function starCostForPart(spriteKey: string, hueId: string): number | undefined {
  if (STARTER_SPRITE_SET.has(spriteKey) && hueId === "blue") return undefined;
  return 2;
}

export function generateCatalogParts(): PartDefinition[] {
  const parts: PartDefinition[] = [];

  for (const sprite of PART_SPRITE_DEFS) {
    for (const hue of ROYGBIV_HUES) {
      const id = partIdForSpriteHue(sprite.key, hue.id);
      const isStarter = STARTER_SPRITE_SET.has(sprite.key) && hue.id === "blue";

      parts.push({
        id,
        name: `${hue.name} ${sprite.label}`,
        category: sprite.category,
        dimensions: spriteGridDimensions(sprite.category),
        shape: sprite.shape,
        spriteKey: sprite.key,
        hueShift: hue.hueShift,
        style: {
          fill: 0x5dade2,
          stroke: 0x2e86c1,
          variant: "standard",
        },
        starter: isStarter,
        starCost: starCostForPart(sprite.key, hue.id),
      });
    }
  }

  return parts;
}
